module.exports = __webpack_public_path__ + "img/TDE_SciFiPoleComp.848c13c5.png";